import React, { useState } from "react";
import PropTypes from "prop-types";

// components:
import Kits from "./Kits";
import ModalButton from "./ModalButton";

// icons:
import Add from "core/ReusableIcons/Add";

// hooks:
import { useAuth } from "frontend/hooks/useAuth";

const SaveToKits = ({ iconId }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const { confirmAuth, isLoggedIn } = useAuth();

    const handleLoggedOut = () => {
        confirmAuth({
            onSuccess: () => setModalOpen(true)
        });
    };

    return !isLoggedIn ? (
        <ModalButton
            tooltipMessage="Add to Kit"
            icon={<Add />}
            onClick={handleLoggedOut}
        />
    ) : (
        <Kits
            iconId={iconId}
            isModalOpen={isModalOpen}
            setModalOpen={setModalOpen}
        />
    );
};

SaveToKits.propTypes = {
    iconId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

export default SaveToKits;
